// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2OO9G","linksContainer":"Footer_linksContainer__2nuCB"};